export enum FormType {
  BasicInfo,
  InterestsAcitivitesGoals,
}
